/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow_bold': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g clip-path="url(#clip0_164_3568)"><path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M0 18.146v9.022l16.04-14.476L32 27.097v-9.022L18.283 5.695a3.349 3.349 0 00-4.487 0L0 18.145z" _fill="#0B2C62"/></g><defs><clipPath id="clip0_164_3568"><path pid="1" _fill="#fff" transform="rotate(-90 16 16)" d="M0 0h32v32H0z"/></clipPath></defs>'
  }
})
